import { colors } from '@kcftech/design-tokens';
import { KCFStyle } from 'styles/themes/KCFStyle';
import type { KCFTheme } from 'styles/themes/KCFTheme';

export const LightTheme: KCFTheme = {
    bodyBackgroundColor: colors.grey['50'],
    backgroundColor: colors.common.white,
    backgroundColorActive: colors.grey['50'],
    shadeBackgroundColor: colors.grey['25'],
    secondaryBackgroundColor: colors.grey['100'],
    activeBackgroundColor1: colors.bluecta['50'],
    activeBackgroundColor2: colors.bluecta['100'],

    navColor: colors.common.white,
    borderColor: colors.grey['100'],
    navBorderColor: colors.grey['200'],
    primaryBoxShadow: KCFStyle.primaryBoxShadow,
    menuBoxShadow: KCFStyle.menuBoxShadow,
    modalBoxShadow: KCFStyle.modalBoxShadow,
    primaryText: colors.grey['900'],
    secondaryText: colors.grey['700'],
    secondaryButton: colors.common.white,
    secondaryButtonHover: colors.grey['50'],
    disabledText: colors.grey['500'],
    cancelButton: colors.grey['100'],
    cancelButtonHover: colors.grey['200'],
    deleteButton: colors.red['700'],
    deleteButtonHover: colors.red['900'],
    warningButton: colors.orange['600'],
    warningButtonHover: colors.orange['700'],
    iconButtonBackgroundHover: colors.grey['200'],
    link: colors.bluecta['600'],
    linkShifted: colors.bluecta['400'],
    title: colors.grey['850'],

    // Form elements
    inputBorder: colors.grey['200'],
    inputBorderFocused: colors.bluecta['600'],
    inputBorderInvalid: colors.red['700'],
    inputBorderValid: colors.green['800'],
    filterRadioButton: colors.grey['500'],

    infoBox: colors.grey['200'],

    // asset cards
    assetCardReportBackgroundColor: colors.grey['850'],

    chartBackgroundColor: colors.common.white,
    chartPlotGridBackgroundColor: colors.grey['50'],

    workbenchHeader: colors.grey['850'],
    workbenchHeaderButtonHover: colors.grey['900'],

    // timeseries
    timeseriesBackgroundColor: colors.common.white,
    timeseriesAxisColor: colors.grey['600'],
    timeseriesGridColor: colors.grey['100'],
    timeseriesDrawerUnselectedColor: colors.grey['100'],
    timeseriesErrorIconColor: colors.orange['700'],
    timeseriesErrorBackgroundColor: colors.orange['100'],

    // treeview
    treeviewIconColor: colors.navy['200'],
    activityLineColor: colors.grey['400'],
    markerTableSelectedColor: colors.bluecta['50'],

    // icons
    iconColor: colors.navy['200'],

    // notifications
    notificationsCog: colors.grey['400'],
    notificationsHeaderText: colors.navy['700'],

    // Tabs
    tabSelected: colors.grey['100'],
    tabsBottomBorder: colors.grey['100'],

    successToastColor: colors.green['100'],
    errorToastColor: colors.red['100'],

    // popups
    popupBackgroundColor: colors.grey['850'],
    popupText: colors.common.white,

    issueQueueButtonBackgroundColor: colors.grey['200'],

    kcfOnlyLozengeBackground: colors.grey['950'],
    kcfOnlyLozengeText: colors.common.white,

    // Hardware Status Action Button
    hardwareStatusActionButtonBackground: colors.grey['100'],
    hardwareStatusActionButtonBackgroundHover: colors.grey['200'],

    // Alarm severity
    criticalSeverity: colors.red['700'],
    alarmSeverity: colors.orange['600'],
    warningSeverity: colors.yellow['600'],

    dashboardAccentPrimary: colors.blue['500'],
    dashboardAxisText: colors.grey['700'],
};
